// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import router from './router'
import ElementUi from 'element-ui'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './style/style.scss'
import getPageTitle from './utils/get-page-title'
import elDragDialog from '@/directive/el-drag-dialog/index' // 弹框拖拽
import './utils/reset'

router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title, to.meta.noShowTitle)
  next()
})
Vue.use(ElementUi)
Vue.use(Router)
Vue.use(elDragDialog)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js